module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_seven.ede2a902.png";